module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "download-dialog-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.downloadCloseHandle($event)
      }
    }
  }, [_c('div', {
    staticClass: "download-dialog"
  }, [_c('div', {
    staticClass: "platform-card"
  }, [_c('img', {
    staticClass: "platform-icon",
    attrs: {
      "src": require("../assets/images/window_icon.png"),
      "alt": "Windows"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform-name"
  }, [_vm._v("Windows")]), _vm._v(" "), _c('button', {
    staticClass: "download-btn",
    on: {
      "click": function($event) {
        return _vm.downloadHandle('windows')
      }
    }
  }, [_vm._v("点击下载")])]), _vm._v(" "), _c('div', {
    staticClass: "platform-card"
  }, [_c('img', {
    staticClass: "platform-icon",
    attrs: {
      "src": require("../assets/images/mac_icon.png"),
      "alt": "macOS"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform-name"
  }, [_vm._v("macOS")]), _vm._v(" "), _c('button', {
    staticClass: "download-btn",
    on: {
      "click": function($event) {
        return _vm.downloadHandle('mac')
      }
    }
  }, [_vm._v("点击下载")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282df1d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadDialog.vue
// module id = 90
// module chunks = 0